import StaffDetail from './staff_detaill.vue'
import ChangeShiftsRecord from './modules/change_shifts_record/change_shifts_record.vue'

export default {
    path: 'staffDetail',
    component: StaffDetail,
    children: [
        {
            path: '',
            redirect: 'changeShiftsRecord'
        },
        {
            path: 'changeShiftsRecord',
            component: ChangeShiftsRecord
        }
    ]
}
